<template>
  <div
    class="jps-infinite-loading"
    v-if="ss.state.result && ss.state.result.hit > 0"
  >
    <div class="jps-infinite-loading-size">
      {{ ss.state.result.list.length }}/{{ ss.state.result.hit }}
    </div>
    <InfiniteLoading
      :identifier="infiniteIdentifier"
      @infinite="infiniteHandler"
    >
      <template #spinner>
        <div :class="{'hina-logo-icon hina-loading': isHina, 'jps-logo-icon jps-loading': isJps}" />
      </template>
      <template #complete>
        <span></span>
      </template>
      <template #error
        >{{ msg }}{{ lss('検索エラー', 'Search Error') }}</template
      >
    </InfiniteLoading>
  </div>
</template>

<script lang="ts" setup>
import InfiniteLoading from 'v3-infinite-loading'

const { lss } = useI18n()
const { isJps, isHina } = useServiceType()

/**
 *
 * ssはfreezeをfalseにしておかないと、検索結果の追加に失敗する
 *
 */
interface Props {
  ss: SearchStore<any>
}
const props = defineProps<Props>()

const infiniteIdentifier = ref('')
const initialized = ref(false)

watch(
  () => props.ss,
  () => {
    if (props.ss && !initialized.value) {
      props.ss.addAfterSearchListener(r => {
        infiniteIdentifier.value = luId()
      })
      initialized.value = true
    }
  },
  { immediate: true },
)

const msg = ref(null)

const infiniteHandler = async infiniteState => {
  try {
    if (props.ss.state.result.list.length >= props.ss.state.result.hit) {
      infiniteState.complete()
      return
    }
    await props.ss.appendNextSearch()
    if (props.ss.state.result.list.length >= props.ss.state.result.hit) {
      infiniteState.complete()
    } else {
      infiniteState.loaded()
    }
  } catch (e) {
    msg.value = e
    infiniteState.error()
  }
}
</script>

<style lang="scss" scoped>
.jps-infinite-loading {
  width: 100%;

  .jps-infinite-loading-size {
    margin-top: 0.5rem;
    text-align: center;
    font-weight: bold;
  }
  .jps-logo-icon {
    margin: 0.5rem auto;
  }

  .hina-logo-icon {
    margin: 0.5rem auto;
  }
  margin-bottom: 3rem;
}
</style>
